(function () {
  const STORAGE_KEY = 'engravingPayload';
  const COOKIE_KEY = 'engravingPayload';

  const FONTS = [
    { key: 'bebas', label: 'Font 1', css: "'Bebas Neue', sans-serif", preview: 'Font 1: Daisy Duke Charlie Bella Lucy' },
    { key: 'montserrat', label: 'Font 2', css: 'Montserrat, sans-serif', preview: 'Font 2: Daisy Duke Charlie Bella Lucy' },
    { key: 'poppins', label: 'Font 3', css: 'Poppins, sans-serif', preview: 'Font 3: Daisy Duke Charlie Bella Lucy' },
    { key: 'dancing', label: 'Font 4', css: "'Dancing Script', cursive", preview: 'Font 4: Daisy Duke Charlie Bella Lucy' },
    { key: 'pacifico', label: 'Font 5', css: 'Pacifico, cursive', preview: 'Font 5: Daisy Duke Charlie Bella Lucy' },
    { key: 'lobster', label: 'Font 6', css: 'Lobster, cursive', preview: 'Font 6: Daisy Duke Charlie Bella Lucy' }
  ];

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function setCookie(name, value, days = 30) {
    const maxAge = days * 24 * 60 * 60;
    document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; samesite=lax';
  }

  function getCookie(name) {
    const safeName = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1');
    const match = document.cookie.match(new RegExp('(?:^|; )' + safeName + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function deleteCookie(name) {
    document.cookie = name + '=; path=/; max-age=0; samesite=lax';
  }

  function getForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function loadSaved() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) return JSON.parse(raw);
    } catch (error) {}

    try {
      const rawCookie = getCookie(COOKIE_KEY);
      if (!rawCookie) return null;

      localStorage.setItem(STORAGE_KEY, rawCookie);
      return JSON.parse(rawCookie);
    } catch (error) {
      return null;
    }
  }

  window.__engravingLoadSaved = loadSaved;

  function savePayload(payload) {
    const raw = JSON.stringify(payload);

    try {
      localStorage.setItem(STORAGE_KEY, raw);
    } catch (error) {}

    setCookie(COOKIE_KEY, raw, 30);
  }

  function clearPayload() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {}

    deleteCookie(COOKIE_KEY);
  }

  function upsertHidden(form, name, value) {
    if (!form) return;

    let input = form.querySelector('input[name="' + name + '"]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }

    input.value = value || '';
  }

  function removeHidden(form, name) {
    if (!form) return;

    const input = form.querySelector('input[name="' + name + '"]');
    if (input) input.remove();
  }

  function applyPayloadToForm(payload) {
    const form = getForm();
    if (!form || !payload) return;

    upsertHidden(form, 'properties[Engraving Line 1]', payload.line1);

    if (payload.line2) upsertHidden(form, 'properties[Engraving Line 2]', payload.line2);
    else removeHidden(form, 'properties[Engraving Line 2]');

    if (payload.line3) upsertHidden(form, 'properties[Engraving Line 3]', payload.line3);
    else removeHidden(form, 'properties[Engraving Line 3]');

    upsertHidden(form, 'properties[Engraving Font]', payload.font || '');
    if (payload.buckleColor) {
  upsertHidden(form, 'properties[Buckle Color]', payload.buckleColor);
} else {
  removeHidden(form, 'properties[Buckle Color]');
}
  }

  function removePayloadFromForm() {
    const form = getForm();
    if (!form) return;

    [
      'properties[Engraving Line 1]',
      'properties[Engraving Line 2]',
      'properties[Engraving Line 3]',
      'properties[Engraving Font]',
      'properties[Buckle Color]'
    ].forEach((name) => removeHidden(form, name));
  }

  function fontKeyFromLabel(label) {
    const lower = String(label || '').toLowerCase();
    const found = FONTS.find((font) => font.label.toLowerCase() === lower);
    return found ? found.key : 'montserrat';
  }

  ready(function () {
    const modal = document.getElementById('engraveModal');
    const card = modal ? modal.querySelector('.engrave-card') : null;
const scrollArea = modal ? modal.querySelector('.engrave-scroll') : null;
    const openBtn = document.getElementById('engraveOpen');
    const closeBtn = document.getElementById('engraveClose');
    const backdrop = document.getElementById('engraveBackdrop');
    const confirmBtn = document.getElementById('engraveConfirm');
    const removeBtn = document.getElementById('engraveRemove');

    const line1Input = document.getElementById('engraveName');
    const line2Input = document.getElementById('engravePhone');
    const line3Input = document.getElementById('engraveLine3');

    const line1Preview = document.getElementById('engraveLine1Preview');
    const line2Preview = document.getElementById('engraveLine2Preview');
    const line3Preview = document.getElementById('engraveLine3Preview');

    const nameCount = document.getElementById('nameCount');
    const phoneCount = document.getElementById('phoneCount');
    const line3Count = document.getElementById('line3Count');

    const fontDropup = document.getElementById('engraveFontDropup');
    const fontTrigger = document.getElementById('engraveFontTrigger');
    const fontMenu = document.getElementById('engraveFontMenu');
    const fontLabel = document.getElementById('engraveFontLabel');

    const buckleOverlayImg = document.getElementById('buckleOverlay');
    const swatches = Array.from(document.querySelectorAll('.buckle-swatch'));
    const presetButtons = Array.from(document.querySelectorAll('#line2Presets .engrave-chip'));

    if (!modal || !openBtn || !closeBtn || !confirmBtn) return;
    if (!line1Input || !line2Input || !line3Input) return;
    if (!line1Preview || !line2Preview || !line3Preview) return;
    if (!fontTrigger || !fontMenu || !fontLabel) return;

    let summaryEl = document.getElementById('engraveSummary');

    if (!summaryEl && openBtn.parentElement) {
      summaryEl = document.createElement('div');
      summaryEl.id = 'engraveSummary';
      summaryEl.className = 'engrave-summary';
      openBtn.insertAdjacentElement('afterend', summaryEl);
    }

    let activeFontKey = 'bebas';
    let activeBuckleColor = '';
    let activeBuckleOverlayUrl = '';
    let previewRaf = null;

    function isMobile() {
      return window.matchMedia('(max-width: 768px)').matches;
    }
/* ==========================================
   MOBILE KEYBOARD / VISUAL VIEWPORT
   ========================================== */

function fitModalToKeyboard() {
  if (!isMobile() || !card || !window.visualViewport) return;

  const vv = window.visualViewport;

  /*
   * visualViewport.height = actual visible browser area
   * after the keyboard opens.
   */
  const availableHeight = Math.max(300, vv.height - 16);

  card.style.setProperty(
    'height',
    availableHeight + 'px',
    'important'
  );

  card.style.setProperty(
    'max-height',
    availableHeight + 'px',
    'important'
  );

  /*
   * Chrome/iOS may shift the visual viewport.
   * Account for that here.
   */
  card.style.setProperty(
    'margin-top',
    (vv.offsetTop + 8) + 'px',
    'important'
  );

  card.style.setProperty(
    'margin-bottom',
    '0px',
    'important'
  );
}


function resetMobileKeyboardLayout() {
  if (!card) return;

  modal.classList.remove('is-typing');

  card.style.removeProperty('height');
  card.style.removeProperty('max-height');
  card.style.removeProperty('margin-top');
  card.style.removeProperty('margin-bottom');
}


function scrollEngravingInputIntoView(input) {
  if (!isMobile() || !scrollArea || !input) return;

  /*
   * Don't use window.scrollIntoView here.
   * We only want to scroll .engrave-scroll,
   * not the Shopify page behind the modal.
   */
  requestAnimationFrame(function () {

    const inputRect = input.getBoundingClientRect();
    const scrollRect = scrollArea.getBoundingClientRect();

    const target =
      scrollArea.scrollTop +
      inputRect.top -
      scrollRect.top -
      70;

    scrollArea.scrollTo({
      top: Math.max(0, target),
      behavior: 'smooth'
    });

  });
}


function handleEngravingFocus(event) {
  if (!isMobile()) return;

  const input = event.currentTarget;

  modal.classList.add('is-typing');

  /*
   * First adjustment immediately.
   */
  requestAnimationFrame(function () {
    fitModalToKeyboard();
  });

  /*
   * iOS keyboard animation takes a moment.
   * Recalculate after it finishes.
   */
  setTimeout(function () {
    fitModalToKeyboard();
    scrollEngravingInputIntoView(input);
  }, 350);
}


function handleEngravingBlur() {
  if (!isMobile()) return;

  /*
   * Delay allows customer to move directly
   * Line 1 -> Line 2 -> Line 3 without the
   * preview flashing back between inputs.
   */
  setTimeout(function () {

    const active = document.activeElement;

    const anotherEngravingInput =
      active === line1Input ||
      active === line2Input ||
      active === line3Input;

    if (!anotherEngravingInput) {
      resetMobileKeyboardLayout();
    }

  }, 200);
}
    function setOpenButtonState(payload) {
      if (payload && payload.line1) {
        openBtn.innerHTML = '✅ Personalized! <span class="cute-edit">(Edit)</span>';
        openBtn.setAttribute('data-engraving-added', 'true');
      } else {
        // openBtn.innerHTML = '🖋️ Click to Personalize → <span class="cute-free">FREE!</span>';
        openBtn.removeAttribute('data-engraving-added');
      }
    }

    function setInlineSummary(payload) {
      if (!summaryEl) return;

      if (payload && payload.line1) {
        const parts = [payload.line1, payload.line2, payload.line3].filter(Boolean);
        const color = payload.buckleColor ? ' • ' + payload.buckleColor : '';

        summaryEl.style.display = 'block';
        summaryEl.textContent = (parts.join(' • ') + ' • ' + (payload.font || '') + color).trim();
      } else {
        summaryEl.style.display = 'none';
        summaryEl.textContent = '';
      }
    }

    function setRemoveVisibility(payload) {
      if (!removeBtn) return;
      removeBtn.style.display = payload && payload.line1 ? 'block' : 'none';
    }

    function setBuckleOverlay(url) {
      if (!buckleOverlayImg) return;

      if (!url) {
        buckleOverlayImg.removeAttribute('src');
        buckleOverlayImg.style.display = 'none';
        return;
      }

      buckleOverlayImg.src = url;
      buckleOverlayImg.style.display = 'block';
    }

    function setBuckleColor(color, overlayUrl) {
      activeBuckleColor = color || '';
      activeBuckleOverlayUrl = overlayUrl || '';

      setBuckleOverlay(activeBuckleOverlayUrl);

      swatches.forEach((btn) => {
        const isActive = btn.getAttribute('data-color') === activeBuckleColor;
        btn.classList.toggle('isActive', isActive);
        btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
      });
    }

    function updatePreviewNow() {
      const v1 = (line1Input.value || '').trim();
      const v2 = (line2Input.value || '').trim();
      const v3 = (line3Input.value || '').trim();

      line1Preview.textContent = v1 || 'Pet Name';
      line1Preview.style.display = 'block';

      line2Preview.textContent = v2;
      line2Preview.style.display = v2 ? 'block' : 'none';

      line3Preview.textContent = v3;
      line3Preview.style.display = v3 ? 'block' : 'none';

      if (nameCount) nameCount.textContent = line1Input.value.length + '/12';
      if (phoneCount) phoneCount.textContent = line2Input.value.length + '/15';
      if (line3Count) line3Count.textContent = line3Input.value.length + '/15';
    }

    function updatePreview() {
      if (previewRaf) return;

      previewRaf = requestAnimationFrame(() => {
        previewRaf = null;
        updatePreviewNow();
      });
    }

    function buildFontMenu() {
      fontMenu.innerHTML = FONTS.map((font) => {
        return (
          '<button type="button" class="engraveFontOption" data-font="' + font.key + '">' +
            '<span class="engraveFontPreview" style="font-family:' + font.css + ';">' + font.preview + '</span>' +
            '<span class="engraveFontCheck" data-check="' + font.key + '">✓</span>' +
          '</button>'
        );
      }).join('');

      fontMenu.classList.remove('is-open');
    }

    function closeFontMenu() {
      fontMenu.classList.remove('is-open');
    }

    function toggleFontMenu() {
      fontMenu.classList.toggle('is-open');
    }

    function setFont(key) {
      const found = FONTS.find((font) => font.key === key) || FONTS[0];

      activeFontKey = found.key;

      fontLabel.textContent = found.label;
      fontLabel.style.fontFamily = found.css;

      line1Preview.style.fontFamily = found.css;
      line2Preview.style.fontFamily = found.css;
      line3Preview.style.fontFamily = found.css;

      fontMenu.querySelectorAll('.engraveFontCheck').forEach((el) => {
        el.style.opacity = el.getAttribute('data-check') === activeFontKey ? '1' : '0';
      });
    }

function openModal() {

  resetMobileKeyboardLayout();

  modal.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');

  document.body.style.overflow = 'hidden';

  const saved = loadSaved();
  setRemoveVisibility(saved);

  if (!isMobile()) {
    requestAnimationFrame(() => line1Input.focus());
  }
}

function closeModal() {

  /* Close keyboard first if an input is active */
  if (
    document.activeElement === line1Input ||
    document.activeElement === line2Input ||
    document.activeElement === line3Input
  ) {
    document.activeElement.blur();
  }

  resetMobileKeyboardLayout();

  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');

  document.body.style.overflow = '';

  closeFontMenu();

  /*
   * Don't focus the opener again on mobile.
   * Mobile browsers sometimes scroll the page when
   * focus() is called after closing a modal.
   */
  if (!isMobile()) {
    openBtn.focus();
  }
}

    function fillModalFromPayload(payload) {
      if (!payload) return;

      line1Input.value = payload.line1 || '';
      line2Input.value = payload.line2 || '';
      line3Input.value = payload.line3 || '';

      setFont(fontKeyFromLabel(payload.font));
      setBuckleColor(payload.buckleColor || 'Gold', payload.buckleOverlayUrl || '');

      updatePreviewNow();
    }

    function clearModalUI() {
      line1Input.value = '';
      line2Input.value = '';
      line3Input.value = '';

      setFont('bebas');
      setBuckleColor('', '');

      updatePreviewNow();
    }

    function syncUI(payload) {
      if (payload) {
        applyPayloadToForm(payload);
        setOpenButtonState(payload);
        setInlineSummary(payload);
        setRemoveVisibility(payload);
        fillModalFromPayload(payload);
      } else {
        setOpenButtonState(null);
        setInlineSummary(null);
        setRemoveVisibility(null);
        clearModalUI();
      }
    }

    buildFontMenu();
    setFont('bebas');

    swatches.forEach((btn) => {
      btn.addEventListener('click', function () {
        setBuckleColor(btn.getAttribute('data-color'), btn.getAttribute('data-overlay'));
      });
    });

    presetButtons.forEach((btn) => {
      btn.addEventListener('click', function () {
        const text = btn.textContent.trim();

        line2Input.value = text.substring(0, line2Input.maxLength);
        line2Input.dispatchEvent(new Event('input', { bubbles: true }));

        presetButtons.forEach((button) => button.classList.remove('isActive'));
        btn.classList.add('isActive');
      });
    });

    fontTrigger.addEventListener('click', toggleFontMenu);

    fontMenu.addEventListener('click', function (event) {
      const btn = event.target.closest('.engraveFontOption');
      if (!btn) return;

      setFont(btn.getAttribute('data-font'));
      closeFontMenu();
      updatePreview();
    });

    document.addEventListener('click', function (event) {
      if (fontDropup && !fontDropup.contains(event.target)) closeFontMenu();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeFontMenu();

        if (modal.classList.contains('is-open')) {
          closeModal();
        }
      }
    });

    openBtn.addEventListener('click', function () {
      const saved = loadSaved();

      if (saved) fillModalFromPayload(saved);
      else clearModalUI();

      openModal();
    });

    closeBtn.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);

    if (removeBtn) {
      removeBtn.addEventListener('click', function () {
        clearPayload();
        removePayloadFromForm();
        syncUI(null);
        closeModal();
      });

      removeBtn.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          removeBtn.click();
        }
      });
    }

    line1Input.addEventListener('input', updatePreview);
    line2Input.addEventListener('input', updatePreview);
    line3Input.addEventListener('input', updatePreview);
/* Mobile keyboard handling */
[line1Input, line2Input, line3Input].forEach(function (input) {

  input.addEventListener('focus', handleEngravingFocus);
  input.addEventListener('blur', handleEngravingBlur);

  /* Return / Done / Enter */
  input.addEventListener('keydown', function (event) {

    if (event.key === 'Enter') {
      event.preventDefault();

      input.blur();
      resetMobileKeyboardLayout();
    }

  });

});
/*
 * Chrome/Safari/Facebook browser can resize or move
 * visualViewport several times during keyboard animation.
 */
if (window.visualViewport) {

  window.visualViewport.addEventListener('resize', function () {

    if (
      isMobile() &&
      modal.classList.contains('is-typing')
    ) {
      fitModalToKeyboard();
    }

  });

  window.visualViewport.addEventListener('scroll', function () {

    if (
      isMobile() &&
      modal.classList.contains('is-typing')
    ) {
      fitModalToKeyboard();
    }

  });

}
    confirmBtn.addEventListener('click', function () {
      const line1 = (line1Input.value || '').trim();
      const line2 = (line2Input.value || '').trim();
      const line3 = (line3Input.value || '').trim();

      if (!line1) {
        alert('Please enter a name for Line 1.');
        return;
      }

      const fontObj = FONTS.find((font) => font.key === activeFontKey) || FONTS[0];

      const payload = {
        line1,
        line2,
        line3,
        font: fontObj.label,
        buckleColor: activeBuckleColor || '',
        buckleOverlayUrl: activeBuckleOverlayUrl || ''
      };

      savePayload(payload);
      applyPayloadToForm(payload);
      setOpenButtonState(payload);
      setInlineSummary(payload);
      setRemoveVisibility(payload);
      closeModal();
    });

    syncUI(loadSaved());

    const form = getForm();

    if (form && form.parentElement) {
      let applyRaf = null;

      const observer = new MutationObserver(function () {
        if (applyRaf) return;

        applyRaf = requestAnimationFrame(function () {
          applyRaf = null;
          const latest = loadSaved();
          if (latest) applyPayloadToForm(latest);
        });
      });

      observer.observe(form.parentElement, {
        childList: true,
        subtree: true
      });
    }
  });
})();